import { useEffect } from 'react';

import { use$ } from '@legendapp/state/react';
import { ReferenceDisclaimerKind } from '@volkswagen-onehub/disclaimer-manager';

import { rootStore } from '../root-store';
import { disclaimerStoreActions } from '../stores/disclaimer-store';
import { featureAppStore } from '../stores/feature-app-store';

interface TextWithReferences {
	[k: string]: string;
}

interface Options {
	id: string;
	text: TextWithReferences | string;
	namedReference?: string;
	isOpenOnLoad?: boolean;
}

export function useDisclaimerState({ id, text, isOpenOnLoad }: Options) {
	const [currentModelKey] = use$(rootStore.currentModel);

	const disclaimerKind: ReferenceDisclaimerKind = 'module-reference';
	const disclaimerManagerScoped = featureAppStore.featureServices['disclaimer-manager'].getScopedDisclaimerManager();

	const concatenatedText = Object.values(text).join('\n');

	useEffect(() => {
		disclaimerManagerScoped.registerReferenceDisclaimer(disclaimerKind, concatenatedText, 'i');

		if (isOpenOnLoad && !disclaimerStoreActions.isDisclaimerHasBeenSeen(currentModelKey)) {
			disclaimerStoreActions.openDisclaimer(id);
			disclaimerStoreActions.setActiveDisclaimer(id);
		}

		if (disclaimerStoreActions.isDisclaimerHasBeenSeen(currentModelKey)) {
			disclaimerStoreActions.setActiveDisclaimer(undefined);
		}

		return () => {
			disclaimerManagerScoped.unregisterReferenceDisclaimer(disclaimerKind, concatenatedText);
		};
	}, [currentModelKey, isOpenOnLoad, id]);
}
